import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Film, Package, GitMerge, LogOut, ExternalLink } from "lucide-react";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "admin-nav-dashboard" },
  { to: "/admin/review", label: "Review Queue", icon: Film, testid: "admin-nav-review" },
  { to: "/admin/products", label: "Products", icon: Package, testid: "admin-nav-products" },
  { to: "/admin/duplicates", label: "Duplicates", icon: GitMerge, testid: "admin-nav-duplicates" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B0B0C] flex relative z-[2]">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-white/10 bg-[#0B0B0C] fixed inset-y-0 flex flex-col">
        <div className="p-6 border-b border-white/10">
          <Link to="/admin" className="font-serif text-2xl tracking-[0.3em]">LUXBEL</Link>
          <p className="overline mt-1 text-[9px]">Review Studio</p>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-sm text-sm transition-all duration-300 ${
                  isActive ? "bg-[#D4AF37]/10 text-[#D4AF37] border-l-2 border-[#D4AF37]" : "text-[#8E8E9A] hover:text-[#F8F6F0] hover:bg-white/5"
                }`
              }
            >
              <it.icon size={17} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2">
          <Link to="/" target="_blank" className="flex items-center gap-2 px-4 py-2 text-xs text-[#8E8E9A] hover:text-[#D4AF37] transition-colors">
            <ExternalLink size={13} /> View Live Site
          </Link>
          <div className="px-4 py-1 text-xs text-[#8E8E9A] font-mono truncate">{user?.email}</div>
          <button
            data-testid="admin-logout-button"
            onClick={async () => {
              await logout();
              navigate("/admin/login");
            }}
            className="flex items-center gap-2 px-4 py-2 text-xs text-[#8E8E9A] hover:text-red-400 transition-colors w-full"
          >
            <LogOut size={13} /> Sign Out
          </button>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 ml-64 p-8 lg:p-12 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
